module.exports = __webpack_public_path__ + "img/logo-card-safe.bcd243c1.png";